import { type TScreenName } from '../types/screenNameTypes'

// Screens that render alike collapse into one label. The set is audio-web's: both tiers feed one
// perf dashboard.
export type TPageType =
    | 'audio'
    | 'search'
    | 'category'
    | 'user'
    | 'auth'
    | 'tour'
    | 'main'
    | 'collection'
    | 'tools'
    | 'other'

const SCREEN_TO_PAGE_TYPE: Partial<Record<TScreenName, TPageType>> = {
    audio: 'audio',

    search: 'search',

    categories_page: 'category',
    category_page: 'category',
    genres_hub_page: 'category',
    genre_page: 'category',
    subgenre_page: 'category',

    // Own-account settings under /profile are a different layout behind auth and stay in `other`
    user_audio: 'user',
    user_collections: 'user',
    user_projects: 'user',
    user_promo_pages: 'user',

    auth: 'auth',

    tour: 'tour',

    // '/' is the main page; `browse` is its screen name
    browse: 'main',

    collection: 'collection',

    converter_main: 'tools',
    transcription_main: 'tools',
    video_to_mp3_main: 'tools',
    vremover_main: 'tools',
    splitter_main: 'tools',
    vextractor_main: 'tools',
    iextractor_main: 'tools',
}

export const getPageType = (screen: TScreenName): TPageType =>
    SCREEN_TO_PAGE_TYPE[screen] ?? 'other'
